import type {
  KambiCouponUnauthorizedErrorResponse,
  KambiCouponValidateSuccessResponse,
  KambiCouponPlaceSuccessResponse,
} from '@mobi/api-types/kambi/player/coupon'
import { post } from '@classic/Foundation/Services/ApiService'
import { store } from '@core/Store'
import { selectPlayerSessionId } from '@core/Areas/KambiClient/Store/selectors'
import type { KambiBettingParams, KambiPlaceBetBettingParams } from './types'

export const postValidateKambiSportsBet = ({ couponRows, bets }: KambiBettingParams) => {
  return postKambiBetToMobiApi<KambiBettingParams, KambiCouponValidateSuccessResponse>(
    '/api/kambibetting/validate-bet',
    { couponRows, bets }
  )
}

export const postPlaceKambiSportsBet = ({
  couponRows,
  bets,
  copiedBetLoopPostId,
}: KambiBettingParams) => {
  return postKambiBetToMobiApi<KambiPlaceBetBettingParams, KambiCouponPlaceSuccessResponse>(
    '/api/kambibetting/place-bet',
    {
      requestId: createRequestId(),
      couponRows,
      bets,
      copiedBetLoopPostId,
    }
  )
}

// =============
// Local Helpers
// =============

function postKambiBetToMobiApi<TRequest, TResponse>(
  url: string,
  body: TRequest
): Promise<TResponse> {
  const kambiBearerToken = selectPlayerSessionId(store.getState())

  if (!kambiBearerToken) {
    const unauthorizedKambiTokenError: KambiCouponUnauthorizedErrorResponse = {
      status: 401,
      message: 'Unauthorized',
    }
    throw unauthorizedKambiTokenError
  }

  const additionalHeaders = { ['X-Kambi-Bearer']: kambiBearerToken }
  return post<TResponse>({ url, body, additionalHeaders })
}

let sessionCommitCount = 0
function createRequestId(): string {
  return `${Date.now()}-${++sessionCommitCount}`
}
